import React from "react"
import { EquifaxTrade } from '@prescreen/lib/equifax-prequal-report'

interface TradeHistoryGridProps {
  trade: EquifaxTrade
}

const TradeHistoryGrid = ({ trade }: TradeHistoryGridProps) => {
  if (!trade.dateReported) return <div className="text-xs text-gray-500">NO LAST PAYMENT DATE</div>
  
  const maxYear = trade.dateReported.getFullYear()
  const startMonth = trade.dateReported.getMonth()
  const history = [...trade.paymentHistory1to24]
  history.splice(12, 1)
  
  const monthLabels = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
  
  return (
    <div className="trade-history-grid">
      {/* Header row */}
      <div className="flex">
        <div className="w-12"></div>
        {monthLabels.map((label, idx) => (
          <div key={idx} className="text-center p-0.5 border border-gray-300 w-5 text-xs">
            {label}
          </div>
        ))}
      </div>
      
      {/* Year rows */}
      {[maxYear, maxYear - 1, maxYear - 2].map(year => (
        <div key={year} className="flex flex-row-reverse">
          {[12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map(month => {
            let value = ''
            if (year === maxYear) {
              value = month > startMonth ? '' : (history[startMonth - month]?.code || '')
            } else if (year === maxYear - 1) {
              value = history[12 + startMonth - month]?.code || ''
            } else {
              const idx = 24 + startMonth - month
              value = idx < history.length ? (history[idx]?.code || '') : ''
            }
            return (
              <div key={month} className="text-center p-0.5 border border-gray-300 w-5 text-xs">
                {value}
              </div>
            )
          })}
          <div className="w-12 text-xs font-medium text-right pr-1">{year}</div>
        </div>
      ))}
    </div>
  )
}

export default TradeHistoryGrid